define('frontend-common-components/gettingStartedPanel/js/views/layouts/gettingStartedLayoutView',[
        'marionette',
        'backbone',
        'hbs!../../../templates/layouts/gettingStartedLayoutTmpl',
        'underscore',
        '../collections/actionItemCollectionView',
        '../../models/actionModel',
        '../../constants/events'
    ],
    function(Marionette, Backbone, gettingStartedLayoutTmpl, _, ActionItemCollectionView, ActionModel, events) {
        'use strict';
        return Marionette.LayoutView.extend(_.extend({

            template: gettingStartedLayoutTmpl,

            className: 'getting-started-layout',

            ui: {
                'title': '.getting-started-title',
                'close': '.getting-started-close'
            },

            events: {
                'click @ui.close': 'onClickCloseLayout'
            },

            regions: {
                actionRegionsBody: '.actions-regions-body'
            },

            initialize: function (options) {
                if(_.isArray(options.actionItems)) {
                    var actionItemModels = this.getActionItemModels(options.actionItems),
                        collection = new Backbone.Collection(actionItemModels),
                        events = this.getActionItemEvents(options.actionItems);

                    this.actionItemCollectionView = new ActionItemCollectionView({
                        collection: collection,
                        modelViewOptions: events
                    });
                }
            },

            onShow: function () {
                this.actionRegionsBody.show(this.actionItemCollectionView);
            },

            getActionItemModels: function(actionItems) {
                return _.map(actionItems, function(item) {
                    return new ActionModel(_.omit(item, 'events'));
                });
            },

            getActionItemEvents: function(actionItems) {
                return _.map(actionItems, function(item) {
                    return item.events;
                });
            },

            updateItem: function(viewTitle, options) {
                if(this.checkOptions(options)) {
                    var model = this.findModelByTitle(viewTitle);
                    var viewToUpdate = this.actionItemCollectionView.children.findByModel(model);
                    if(_.isEmpty(viewToUpdate) === false) {
                        viewToUpdate.setOptionsInModel(options);
                    }
                }
            },

            findModelByTitle: function(viewTitle) {
                return _.find(this.actionItemCollectionView.collection.models, function(model) {
                    if(model.get('title') === viewTitle) {
                        return model;
                    }
                });
            },

            checkOptions: function(options) {
                return _.isEmpty(options) === false;
            },

            hideLayout: function() {
                this.$el.hide();
                this.triggerMethod(events.close);
            },

            showLayout: function() {
                this.$el.show();
            },

            isComplete: function() {
                var isCompleted = true;
                _.each(this.actionItemCollectionView.collection.models, function(model) {
                    if(model.get('completed') === false) {
                        isCompleted = false;
                    }
                });
                return isCompleted;
            },

            onClickCloseLayout: function() {
                this.hideLayout();
            }


        }));
    });

